import React from "react";
import { PricingPlan } from './types';

const PricingCard = (plans: PricingPlan[]) => {
    return (
       <div className="pricing-plans">
            {plans.map((plan, index) => (
                <div 
                    key={index} 
                    className={`pricing-card ${plan.recommended ? 'pricing-card--recommended' : ''}`}
                >
                    {plan.recommended && (
                        <div className="pricing-card__badge">Popular</div>
                    )}
                    <div className="pricing-card__header">
                        <h3 className="pricing-card__name">{plan.name}</h3>
                        <p className="pricing-card__subtitle">{plan.subtitle}</p>
                    </div>
                    <div className="pricing-card__price">
                        <div className="pricing-card__price-amount">{plan.price}</div>
                        <div className="pricing-card__price-period">{plan.period}</div>
                        {plan.annualPrice && (
                            <div className="pricing-card__annual-price">{plan.annualPrice}</div>
                        )}
                    </div>
                    <ul className="pricing-card__features">
                        {plan.features.map((feature, featureIndex) => (
                            <li 
                                key={featureIndex} 
                                className={`pricing-card__feature ${feature.included ? 'pricing-card__feature--included' : 'pricing-card__feature--excluded'}`}
                            >
                                <span className="pricing-card__feature-icon">
                                    {feature.included ? '✓' : '✗'}
                                </span>
                                <span className="pricing-card__feature-text">{feature.text}</span>
                            </li>
                        ))}
                        <li style={{display: plan.planLink ? 'block' : 'none'}}><a href={plan.planLink} className="pricing-card__link">Learn more</a></li>
                    </ul>
                    <a 
                        href={plan.button.buttonLink} 
                        className={`pricing-card__button ${plan.button.buttonColor}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {plan.button.buttonText}
                    </a>
                </div>
            ))}
        </div>
    );
};

export default PricingCard;
